// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rich-text iframe,.rich-text img{margin-block:var(--size-7)}.rich-text>p{margin-bottom:var(--size-7)}.rich-text img{aspect-ratio:3/2;height:auto;-o-object-fit:cover;object-fit:cover}.rich-text iframe,.rich-text img{border-radius:var(--border-radius-2);width:100%}.rich-text iframe{aspect-ratio:16/9}@media (min-width:40rem){.rich-text{margin:0 auto;max-width:45rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
